<form class="form-horizontal" autocomplete="off" #createOrEditReminderForm="ngForm" (ngSubmit)="save()"
    (keydown.enter)="preventEnter($event)">
    <abp-modal-header [title]="title" [minimizedTitle]="title" (onCloseClick)="handleOnClose()" [hideMaximize]="true"
        (onMaximizeClick)="maximizeRestore($event)" [modalId]="'createReminder' + reminderId"
        (onMinimizeClick)="minimizeRestore($event)">
    </abp-modal-header>
    <div class="modal-body">
        <div class="summary-text mb-4" *ngIf="reminder.id > 0">
            <p class="mb-1">{{ "Summary" | localize }}:</p>
            <p>{{ summaryText }}</p>
        </div>
        <div class="form-fields-container">
            <div class="aux-title-cont-header">
                <h5 class="uppercase">{{ "General" | localize }}</h5>
            </div>
            <div class="row w-100">
                <div class="col-6">
                    <div class="input-label-cont extra priority-full">
                        <label for="reminderType" class="d-flex align-items-center required">
                            {{ "Type" | localize }}
                            &nbsp;&nbsp;
                            <i *ngIf="canEditRemindersTypes" class="fa fa-pencil pointer ms-2"
                                [title]="'EditOptions' | localize" (click)="toggleTypeEditMode()"></i>
                        </label>
                        <div *ngIf="!isEditingTypeOptions" class="input-cont icon-addon" style="position: relative;">
                            <input type="text" class="input-txt truncate-text" [id]="'reminderType' + randomTypeId"
                                name="reminderTypeId" [value]="getTypeName(reminder.reminderTypeId)" readonly
                                (click)="toggleTypeDropdown()" autocomplete="off" />
                            <i *ngIf="!reminder.reminderTypeId" class="fa fa-angle-down pointer"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 80%;"
                                (click)="toggleTypeDropdown()">
                            </i>
                            <i *ngIf="reminder.reminderTypeId" class="fa fa-times pointer"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 80%; color: #888;"
                                (click)="clearType()">
                            </i>
                            <div class="dropdown-menu" [ngClass]="{ 'show': showTypeDropdown }"
                                style="position: absolute; top: 100%; left: 0; z-index: 1000;">
                                <div class="dropdown-item" *ngFor="let type of reminderTypes"
                                    (click)="selectType(type.id)">
                                    <span>{{ type.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isEditingTypeOptions" class="priority-full">
                        <div #typeListContainer *ngIf="isEditingTypeOptions" class="bg-light rounded p-3" style="
                    width: 600px;
                    max-width: 80%;
                    margin: 0 auto;
                    min-width: 300px;
                    box-sizing: border-box;
                    margin-top: -1.5rem;
                    max-height: 240px;
                    overflow-y: auto;
                    border: 1px solid #ccc;
                    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
                    z-index: 99 !important;
                " cdkDropList (cdkDropListDropped)="onDropType($event)">
                            <div *ngFor="let type of reminderTypes; let i = index; trackBy: trackByType" cdkDrag
                                [cdkDragData]="type" class="d-flex align-items-center mb-2 small w-100"
                                style="gap: 0.5rem;">
                                <span cdkDragHandle class="handle-icon">☰</span>
                                <input type="text" class="form-control form-control-sm"
                                    style="font-size: 0.8rem; padding: 0.2rem 0.5rem; flex-grow: 1; box-shadow: none;"
                                    [(ngModel)]="type.name" [ngModelOptions]="{ standalone: true }"
                                    [name]="'noteTypeName' + i" [placeholder]="'TypeName' | localize" />
                                <button type="button"
                                    class="btn btn-sm p-0 text-muted d-flex align-items-center justify-content-center"
                                    (click)="!isTypeInUse(type) && deleteType(i, $event)" [disabled]="isTypeInUse(type)"
                                    [pTooltip]="isTypeInUse(type) ? ('ItIsNotPossibleToDeleteAnOptionThatIsBeingUsed' | localize) : ('Delete' | localize)"
                                    tooltipPosition="top" style="background: none; border: none; height: 100%;">
                                    <i class="material-icons-outlined" [ngStyle]="{
                                         fontSize: '17px',
                                         opacity: isTypeInUse(type) ? '0.4' : '1',
                                         color: isTypeInUse(type) ? '#999' : ''
                                       }">delete</i>
                                </button>
                                <ng-template cdkDragPreview>
                                    <div class="drag-preview-clean">
                                        <span class="handle-icon">☰</span>
                                        <span class="text-truncate content-text">
                                            {{ type.name }}
                                        </span>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="d-flex mt-3 small align-items-center w-100" style="gap: 0.5rem;">
                                <input type="text" class="form-control form-control-sm" name="newType"
                                    style="font-size: 0.8rem; padding: 0.2rem 0.5rem; flex-grow: 1; box-shadow: none;"
                                    [placeholder]="'NewType' | localize" [(ngModel)]="newTypeName"
                                    (keydown.enter)="onEnterAddType($event)" />
                                <button type="button"
                                    class="btn btn-sm p-0 text-muted d-flex align-items-center justify-content-center"
                                    (click)="addType()" style="background: none; border: none; height: 100%;">
                                    <i class="fa fa-level-down-alt"></i>
                                </button>
                            </div>
                            <div class="mt-3 d-flex justify-content-start" style="gap: 0.5rem;">
                                <button type="button" class="btn-aux btn-sm" (click)="cancelEditTypes()"
                                    style="border-radius: 0.25rem;">
                                    {{ "Cancel" | localize }}
                                </button>
                                <button type="button" class="btn-default btn-sm" (click)="saveTypes()"
                                    style="border-radius: 0.25rem;">
                                    {{ "Accept" | localize }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-label-cont extra priority-full">
                        <label for="reminderPriority" class="d-flex align-items-center">
                            {{ "Priority" | localize }}
                            &nbsp;&nbsp;
                            <i *ngIf="canEditRemindersPriorities" class="fa fa-pencil pointer ms-2"
                                [title]="'EditOptions' | localize" (click)="togglePriorityEditMode()"></i>
                        </label>
                        <div *ngIf="!isEditingPriorityOptions" class="input-cont icon-addon"
                            style="position: relative;">
                            <input type="text" class="input-txt truncate-text"
                                [id]="'reminderPriority' + randomPriorityId" name="reminderPriorityId"
                                [value]="getPriorityName(reminder.reminderPriorityId)" readonly
                                (click)="togglePriorityDropdown()" autocomplete="off" />
                            <i *ngIf="!reminder.reminderPriorityId" class="fa fa-angle-down pointer"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 80%;"
                                (click)="togglePriorityDropdown()">
                            </i>
                            <i *ngIf="reminder.reminderPriorityId" class="fa fa-times pointer"
                                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); font-size: 80%; color: #888;"
                                (click)="clearPriority()">
                            </i>
                            <div class="dropdown-menu" [ngClass]="{ 'show': showPriorityDropdown }"
                                style="position: absolute; top: 100%; left: 0; z-index: 1000;">
                                <div class="dropdown-item" *ngFor="let priority of reminderPriorities"
                                    (click)="selectPriority(priority.id)">
                                    <span>{{ priority.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isEditingPriorityOptions" class="priority-full">
                        <div #priorityListContainer class="bg-light rounded p-3" style="
                    width: 600px;
                    max-width: 80%;
                    margin: 0 auto;
                    min-width: 300px;
                    box-sizing: border-box;
                    margin-top: -1.5rem;
                    max-height: 240px;
                    overflow-y: auto;
                    border: 1px solid #ccc;
                    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
                    z-index: 99 !important;
          " cdkDropList (cdkDropListDropped)="onDropPriority($event)">
                            <div *ngFor="let priority of reminderPriorities; let i = index; trackBy: trackByPriority"
                                cdkDrag [cdkDragData]="priority" class="d-flex align-items-center mb-2 small w-100"
                                style="gap: 0.5rem;">
                                <span cdkDragHandle class="handle-icon">☰</span>

                                <input type="text" class="form-control form-control-sm"
                                    style="font-size: 0.8rem; padding: 0.2rem 0.5rem; flex-grow: 1; box-shadow: none;"
                                    [(ngModel)]="priority.name" [ngModelOptions]="{ standalone: true }"
                                    [name]="'priorityName' + i" [placeholder]="'PriorityName' | localize" />

                                <button type="button"
                                    class="btn btn-sm p-0 text-muted d-flex align-items-center justify-content-center"
                                    (click)="!isPriorityInUse(priority) && deletePriority(i, $event)"
                                    [disabled]="isPriorityInUse(priority)"
                                    [pTooltip]="isPriorityInUse(priority) ? ('ItIsNotPossibleToDeleteAnOptionThatIsBeingUsed' | localize) : ('Delete' | localize)"
                                    tooltipPosition="top" style="background: none; border: none; height: 100%;">
                                    <i class="material-icons-outlined" [ngStyle]="{
                                         fontSize: '17px',
                                         opacity: isPriorityInUse(priority) ? '0.4' : '1',
                                         color: isPriorityInUse(priority) ? '#999' : ''
                                       }">delete</i>
                                </button>

                                <ng-template cdkDragPreview>
                                    <div class="drag-preview-clean">
                                        <span class="handle-icon">☰</span>
                                        <span class="text-truncate content-text">
                                            {{ priority.name }}
                                        </span>
                                    </div>
                                </ng-template>
                            </div>

                            <div class="d-flex mt-3 small align-items-center w-100" style="gap: 0.5rem;">
                                <input type="text" class="form-control form-control-sm" name="newPriority"
                                    style="font-size: 0.8rem; padding: 0.2rem 0.5rem; flex-grow: 1; box-shadow: none;"
                                    [placeholder]="'NewPriority' | localize" [(ngModel)]="newPriorityName"
                                    (keydown.enter)="onEnterAddPriority($event)" />
                                <button type="button"
                                    class="btn btn-sm p-0 text-muted d-flex align-items-center justify-content-center"
                                    (click)="addPriority()" style="background: none; border: none; height: 100%;">
                                    <i class="fa fa-level-down-alt"></i>
                                </button>
                            </div>
                            <div class="mt-3 d-flex justify-content-start" style="gap: 0.5rem;">
                                <button type="button" class="btn-aux btn-sm" (click)="cancelEditPriorities()"
                                    style="border-radius: 0.25rem;">
                                    {{ "Cancel" | localize }}
                                </button>
                                <button type="button" class="btn-default btn-sm" (click)="savePriorities()"
                                    style="border-radius: 0.25rem;">
                                    {{ "Accept" | localize }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aux-title-cont-header">
                <h5 class="uppercase">{{ "Assignment" | localize }}</h5>
            </div>
            <div class="row w-100">
                <div class="col-6">
                    <div class="input-label-cont extra priority-full">
                        <label for="recipient" class="required">{{ "Recipient" | localize }}</label>
                        <div class="input-cont icon-addon">
                            <p-multiSelect class="input-txt custom-multiselect w-100" [options]="recipientOptions"
                                [(ngModel)]="assignedRecipientsIds" optionLabel="fullName" optionValue="id"
                                [selectedItemsLabel]="l('SelectedItemsLabel')" (onBlur)="haveChangesToSave = true"
                                [style]="{ width: '100%' }" [filter]="true" [emptyMessage]="'NoResultsFound' | localize"
                                [emptyFilterMessage]="'NoResultsFound' | localize" name="recipient"
                                #recipientMultiselect>
                            </p-multiSelect>
                        </div>
                        <!--
                        <div class="input-cont icon-addon">
                            <input autocomplete="off" type="text" [(ngModel)]="recipientSearchField" class="input-txt"
                                name="recipient" typeaheadOptionField="fullName" [typeahead]="recipientOptions"
                                [typeaheadScrollable]="true" [typeaheadMinLength]="0" [typeaheadSingleWords]="true"
                                (typeaheadOnSelect)="onRecipientSelected($event)" #recipientEl>
                            <i class="fa fa-angle-down pointer" style="font-size: 80%;"
                                (click)="recipientEl.focus()"></i>
                        </div>
                        -->
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-label-cont extra priority-full">
                        <label for="assignedField">{{ "LinkedTo" | localize }}:</label>
                        <div class="input-cont select-style" #comboWrapper
                            (click)="openContextMenu($event); recipientMultiselect.close($event);">
                            <input type="text" class="input-txt" name="assignedField" id="assignedField"
                                [(ngModel)]="assignedFieldSearchField" (ngModelChange)="haveChangesToSave = true"
                                readonly #assignedFieldInput />
                            <i class="fa fa-angle-down" style="font-size: 80%;"></i>
                        </div>
                        <p-contextMenu [model]="assignedFieldMenuItems" #assignedFieldMenu
                            appendTo="createOrEditReminderForm" (onShow)="fixZIndex()">
                        </p-contextMenu>
                    </div>
                </div>
            </div>
            <div class="aux-title-cont-header">
                <h5 class="uppercase">{{ "Description" | localize }}</h5>
            </div>
            <div class="description-full">
                <quill-editor [(ngModel)]="reminder.description" name="description"
                    (ngModelChange)="haveChangesToSave = true" [modules]="quillModules"
                    [placeholder]="'DetailedDescriptionReminder' | localize" class="rich-text-editor spacing-bottom">
                </quill-editor>
            </div>
            <div class="aux-title-cont-header">
                <h5 class="uppercase">{{ "Programming" | localize }}</h5>
            </div>
            <div class="row w-100">
                <div class="col-6">
                    <div class="input-label-cont extra form-grid-item mb-0">
                        <label for="date" class="required">{{ 'Date' | localize }}</label>
                        <div class="input-cont icon-addon">
                            <input type="text" id="date" name="date" class="input-txt"
                                placeholder="{{ getDateInputFormat() }}" #datepicker="bsDatepicker" bsDatepicker
                                (blur)="onDateBlur()"
                                [bsConfig]="{ dateInputFormat: getDateInputFormat(), adaptivePosition: false }"
                                [minDate]="minDate" [(ngModel)]="dateString"
                                (ngModelChange)="manageGenerateDates(); validateDateTime();" #dateModel="ngModel"
                                #dateEl required />
                            <i class="fa-regular fa-calendar calendar-icon"></i>
                        </div>
                        <abp-validation-summary [control]="dateModel" [controlEl]="dateEl"></abp-validation-summary>
                    </div>
                </div>
                <div class="col-6">
                    <div class="input-label-cont extra form-grid-item mb-0">
                        <label for="time" class="required">{{ 'hour' | localize | titlecase }}</label>
                        <div class="input-cont icon-addon">
                            <input type="time" id="time" name="time" class="input-txt" [(ngModel)]="timeString"
                                #timeModel="ngModel" #timeEl required (blur)="validateDateTime()" />
                            <i class="fa-regular fa-clock calendar-icon"></i>
                        </div>
                        <abp-validation-summary [control]="timeModel" [controlEl]="timeEl"></abp-validation-summary>
                    </div>
                </div>
            </div>
            <div class="row w-100">
                <div class="col-6">
                    <div class="ml-auto input-label-cont extra form-grid-item mb-0">
                        <label for="timezone" class="required">{{ 'Timezone' | localize }}</label>
                        <div class="input-cont icon-addon">
                            <input autocomplete="off" type="text" (blur)="validateDateTime()" id="timezone"
                                name="timezone" class="input-txt" [(ngModel)]="selectedTimezone" required
                                [typeahead]="timezoneList" [typeaheadMinLength]="0" [typeaheadScrollable]="true"
                                [typeaheadSingleWords]="true" [dropup]="true"
                                (typeaheadOnSelect)="onTimezoneSelected($event)" #timezoneEl />
                            <i class="fa fa-angle-down pointer" style="font-size: 80%;"
                                (click)="timezoneEl.focus()"></i>
                        </div>
                    </div>
                </div>
                <div class="col-6 align-content-center">
                    <div class="input-label-cont extra form-grid-item align-items-center">
                        <div class="d-flex justify-content-center">
                            <label class="verified-checkbox custom-checkbox lib-item mb-0"
                                [ngClass]="{ checked: repeat }" (click)="manageRepeat()"></label>
                            <span>{{ 'Repeat' | localize }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="repeat">
                <div class="aux-title-cont-header">
                    <h5 class="uppercase">{{ "Repeat" | localize }}</h5>
                </div>
                <div class="w-100">
                    <div class="select-mode mb-4">
                        <p-selectButton [allowEmpty]="false" [options]="repeatModes" [(ngModel)]="repeatModeSelected"
                            optionLabel="label" optionValue="value" [ngModelOptions]="{ standalone: true }" />
                    </div>
                    <div *ngIf="repeatModeSelected == 'Daily'" style="justify-items: center;">
                        <div class="row mb-3 justify-content-center">
                            <div>
                                <div class="input-label-cont extra form-grid-item mb-0">
                                    <label for="rangeStart">{{ 'From' | localize }}</label>
                                    <div class="input-cont select-style">
                                        <input autocomplete="off" id="rangeStart" name="rangeStart" class="input-txt"
                                            [(ngModel)]="fromDateSelected" [typeahead]="weekdays"
                                            typeaheadOptionField="name" [typeaheadMinLength]="0"
                                            [typeaheadOptionsLimit]="7" (typeaheadOnSelect)="onStartSelect($event)"
                                            #fromModel="ngModel" #fromEl />
                                        <i class="fa fa-times pointer" style="font-size: 80%;"
                                            (click)="fromDateSelected = ''; fromModel.control.markAsTouched();"
                                            *ngIf="fromDateSelected"></i>
                                        <i class="fa fa-angle-down" style="font-size: 80%;" (click)="fromEl.focus()"
                                            *ngIf="!fromDateSelected"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="ml-3">
                                <div class="input-label-cont extra form-grid-item mb-0">
                                    <label for="rangeEnd">{{ 'To' | localize }}</label>
                                    <div class="input-cont select-style">
                                        <input autocomplete="off" id="rangeEnd" name="rangeEnd" class="input-txt"
                                            [(ngModel)]="toDateSelected" [typeahead]="weekdays"
                                            typeaheadOptionField="name" [typeaheadMinLength]="0"
                                            [typeaheadOptionsLimit]="7" (typeaheadOnSelect)="onEndSelect($event)"
                                            #toModel="ngModel" #toEl />
                                        <i class="fa fa-times pointer" style="font-size: 80%;"
                                            (click)="toDateSelected = ''; toModel.control.markAsTouched();"
                                            *ngIf="toDateSelected"></i>
                                        <i class="fa fa-angle-down" style="font-size: 80%;" (click)="toEl.focus()"
                                            *ngIf="!toDateSelected"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3 input-label-cont extra form-grid-item mb-0">
                            <label for="endDate">
                                {{ 'EndDate2' | localize }}
                                <span class="question-icon extra-info">
                                    <i class="fa-solid fa-circle-question"
                                        [tooltip]="'EndDateReminderText' | localize"></i>
                                </span>
                            </label>
                            <div class="input-cont icon-addon">
                                <input type="text" id="endDate" name="endDate" class="input-txt"
                                    placeholder="{{ getDateInputFormat() }}" #datepicker="bsDatepicker" bsDatepicker
                                    [bsConfig]="{ dateInputFormat: getDateInputFormat(), adaptivePosition: true }"
                                    [minDate]="minDate" [(ngModel)]="endDateString"
                                    (ngModelChange)="onEndDateChange($event)" (blur)="onEndDateChange($event)"
                                    #endDateModel="ngModel" #endDateEl />
                                <i class="fa-regular fa-calendar calendar-icon"></i>
                            </div>
                            <abp-validation-summary [control]="endDateModel"
                                [controlEl]="endDateEl"></abp-validation-summary>
                        </div>
                    </div>
                    <div *ngIf="repeatModeSelected == 'Weekly'">
                        <div class="row mb-3 justify-content-center">
                            <div class="col-6">
                                <div class="input-label-cont extra form-grid-item">
                                    <label for="endDate">
                                        {{ 'EndDate2' | localize }}
                                        <span class="question-icon extra-info">
                                            <i class="fa-solid fa-circle-question"
                                                [tooltip]="'EndDateReminderText' | localize"></i>
                                        </span>
                                    </label>
                                    <div class="input-cont icon-addon">
                                        <input type="text" id="endDate" name="endDate" class="input-txt"
                                            placeholder="{{ getDateInputFormat() }}" #datepicker="bsDatepicker"
                                            bsDatepicker
                                            [bsConfig]="{ dateInputFormat: getDateInputFormat(), adaptivePosition: true }"
                                            [minDate]="minDate" [(ngModel)]="endDateString"
                                            (blur)="onEndDateChange($event)" (ngModelChange)="onEndDateChange($event)"
                                            #endDateModel="ngModel" #endDateEl />
                                        <i class="fa-regular fa-calendar calendar-icon"></i>
                                    </div>
                                    <abp-validation-summary [control]="endDateModel"
                                        [controlEl]="endDateEl"></abp-validation-summary>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="repeatModeSelected == 'Monthly'">
                        <div class="row mb-3">
                            <div class="col-6">
                                <div class="input-label-cont extra form-grid-item mb-0">
                                    <label for="monthlyOrdinal">{{ 'SelectOrdinal' | localize }}</label>
                                    <div class="input-cont select-style">
                                        <input autocomplete="off" id="monthlyOrdinal" name="monthlyOrdinal"
                                            class="input-txt" [(ngModel)]="monthlyOrdinalInput"
                                            [typeahead]="monthOrdinals" typeaheadOptionField="label"
                                            [typeaheadMinLength]="0" [typeaheadOptionsLimit]="5"
                                            (typeaheadOnSelect)="onMonthlyOrdinalSelect($event)"
                                            #monthlyOrdModel="ngModel" #monthlyOrdEl />
                                        <i class="fa fa-times pointer" style="font-size: 80%;"
                                            *ngIf="monthlyOrdinalInput"
                                            (click)="monthlyOrdinalInput=''; monthlyOrdModel.control.markAsTouched()"></i>
                                        <i class="fa fa-angle-down pointer" style="font-size: 80%;"
                                            *ngIf="!monthlyOrdinalInput" (click)="monthlyOrdEl.focus()"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="input-label-cont extra form-grid-item mb-0">
                                    <label for="endDate">
                                        {{ 'EndDate2' | localize }}
                                        <span class="question-icon extra-info">
                                            <i class="fa-solid fa-circle-question"
                                                [tooltip]="'EndDateReminderText' | localize"></i>
                                        </span>
                                    </label>
                                    <div class="input-cont icon-addon">
                                        <input type="text" id="endDate" name="endDate" class="input-txt"
                                            placeholder="{{ getDateInputFormat() }}" #datepicker="bsDatepicker"
                                            bsDatepicker
                                            [bsConfig]="{ dateInputFormat: getDateInputFormat(), adaptivePosition: true }"
                                            [minDate]="minDate" [(ngModel)]="endDateString"
                                            (blur)="onEndDateChange($event)" (ngModelChange)="onEndDateChange($event)"
                                            #endDateModel="ngModel" #endDateEl />
                                        <i class="fa-regular fa-calendar calendar-icon"></i>
                                    </div>
                                    <abp-validation-summary [control]="endDateModel"
                                        [controlEl]="endDateEl"></abp-validation-summary>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <bs-datepicker-inline bsDatepicker
                            [bsConfig]="{ dateInputFormat: getDateInputFormat(), adaptivePosition: false }"
                            [minDate]="minDate" [dateCustomClasses]="customDateClasses"
                            (bsValueChange)="onDateClick($event)"></bs-datepicker-inline>
                        <div class="d-flex justify-content-center mt-3" style="gap: 0.5rem;">
                            <button type="button" class="btn-aux" (click)="clearDates()" [disabled]="saving">
                                {{ 'ClearDates' | localize }}
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="aux-title-cont-header" *ngIf="!repeat">
                <h5 class="uppercase">{{ "Alert" | localize }}</h5>
            </div>
            <div class="input-label-cont extra form-grid-item" *ngIf="!repeat">
                <label for="notifyBefore">{{ 'NotifyBefore' | localize }}</label>
                <div class="input-cont icon-addon">
                    <input autocomplete="off" type="text" (blur)="validateDateTime()" id="notifyBefore" name="notifyBefore"
                        class="input-txt" [(ngModel)]="selectedNotifyBefore" [typeahead]="notifyBeforeList"
                        [typeaheadMinLength]="0" [typeaheadScrollable]="true" [typeaheadSingleWords]="true" [dropup]="true"
                        (typeaheadOnSelect)="onNotifyBeforeSelected($event)" #notifyBeforeEl />
                    <i class="fa fa-angle-down pointer" style="font-size: 80%;" (click)="notifyBeforeEl.focus()"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex">
            <button type="button" class="btn-aux" [disabled]="saving" (click)="onCloseModal()">
                {{ "Cancel" | localize }}
            </button>
            <button *ngIf="!reminder.paused && reminder.id > 0" type="button" class="btn-default ml-4"
                [disabled]="saving" (click)="managePause()">
                {{ "Pause" | localize }}
            </button>
            <button *ngIf="reminder.paused && reminder.id > 0" type="button" class="btn-default ml-4"
                [disabled]="saving" (click)="managePause()">
                {{ "Unpause" | localize }}
            </button>
        </div>
        <button type="submit" class="btn-default ml-auto"
            [disabled]="!isDateTimeValid || !createOrEditReminderForm.form.valid || saving || assignedRecipientsIds.length == 0 || reminder.reminderTypeId == undefined">
            {{ "Save" | localize }}
        </button>
    </div>
</form>